import axios from "axios";
import { useEffect, useState } from "react";
import { History, Pencil, Plus, Trash2, Tag, Coins, RotateCcw, Mail, Undo2, Repeat, UserCog, HandCoins } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const META = {
  create: { label: "Eklendi", Icon: Plus, cls: "create" },
  update: { label: "Düzenlendi", Icon: Pencil, cls: "update" },
  delete: { label: "Silindi", Icon: Trash2, cls: "delete" },
  restore: { label: "Geri alındı", Icon: RotateCcw, cls: "restore" },
  group_add: { label: "Grup", Icon: Tag, cls: "group" },
  group_rename: { label: "Grup", Icon: Tag, cls: "group" },
  group_delete: { label: "Grup", Icon: Tag, cls: "group" },
  rate_set: { label: "Kur", Icon: Coins, cls: "rate" },
  email_sent: { label: "E-posta", Icon: Mail, cls: "email" },
  recurring: { label: "Otomatik", Icon: Repeat, cls: "recurring" },
  recurring_add: { label: "Tekrar", Icon: Repeat, cls: "recurring" },
  recurring_update: { label: "Tekrar", Icon: Repeat, cls: "recurring" },
  recurring_delete: { label: "Tekrar", Icon: Repeat, cls: "recurring" },
  user_add: { label: "Kullanıcı", Icon: UserCog, cls: "user" },
  user_update: { label: "Kullanıcı", Icon: UserCog, cls: "user" },
  user_delete: { label: "Kullanıcı", Icon: UserCog, cls: "user" },
  user_password: { label: "Şifre", Icon: UserCog, cls: "user" },
  collection_add: { label: "Tahsilat", Icon: HandCoins, cls: "collection" },
  collection_update: { label: "Tahsilat", Icon: HandCoins, cls: "collection" },
  collection_delete: { label: "Tahsilat", Icon: HandCoins, cls: "collection" },
};

const when = iso => new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export default function ActivityLog({ refreshKey, onChanged }) {
  const { can } = useAuth();
  const [logs, setLogs] = useState([]);
  const [action, setAction] = useState("");
  const [notice, setNotice] = useState("");

  useEffect(() => {
    axios.get(`${API}/logs?limit=60${action ? `&action=${action}` : ""}`).then(r => setLogs(r.data)).catch(() => setLogs([]));
  }, [refreshKey, action]);

  const undo = async log => {
    try {
      await axios.post(`${API}/logs/${log.id}/undo`);
      setNotice(log.action === "delete" ? "Kayıt geri yüklendi" : "Kayıt eski haline döndürüldü");
      onChanged?.();
    } catch (e) {
      setNotice(e?.response?.data?.detail || "Geri alınamadı");
    }
  };

  return (
    <section className="panel log-panel" data-testid="activity-log-panel">
      <div className="panel-head">
        <div>
          <p className="eyebrow">İŞLEM GÜNLÜĞÜ</p>
          <h3>Kim ne zaman ne yaptı?</h3>
        </div>
        <select data-testid="log-action-filter" value={action} onChange={e => setAction(e.target.value)}>
          <option value="">Tüm işlemler</option>
          <option value="create">Ekleme</option>
          <option value="update">Düzenleme</option>
          <option value="delete">Silme</option>
          <option value="restore">Geri alma</option>
          <option value="group_add">Grup</option>
          <option value="rate_set">Kur</option>
          <option value="email_sent">E-posta</option>
          <option value="recurring">Otomatik gider</option>
        </select>
      </div>
      {notice && <div className="notice" data-testid="log-notice">{notice}</div>}
      <ul className="log-list" data-testid="activity-log-list">
        {logs.map(log => {
          const { label, Icon, cls } = META[log.action] || { label: log.action, Icon: History, cls: "" };
          return (
            <li key={log.id} className={`log-item ${cls} ${log.undone ? "undone" : ""}`} data-testid={`log-item-${log.id}`}>
              <span className="log-icon"><Icon size={14}/></span>
              <div className="log-body">
                <span className="log-label">{label}{log.undone && " · geri alındı"}</span>
                <p>{log.summary}</p>
                {log.actor && <small className="sub-line" data-testid={`log-actor-${log.id}`}>{log.actor}</small>}
              </div>
              <div className="log-side">
                <time>{when(log.created_at)}</time>
                {log.can_undo && can("edit") && (
                  <button type="button" className="undo-btn" data-testid={`undo-${log.id}`} onClick={() => undo(log)}>
                    <Undo2 size={13}/> {log.action === "delete" ? "Geri yükle" : "Eski haline döndür"}
                  </button>
                )}
              </div>
            </li>
          );
        })}
        {!logs.length && <li className="empty-log">Henüz günlük kaydı yok.</li>}
      </ul>
    </section>
  );
}
